import { Preferences } from "@capacitor/preferences";

export async function getPreference(key: string): Promise<string | null> {
  const { value } = await Preferences.get({ key });
  return value;
}

export async function setPreference(key: string, value: string): Promise<void> {
  await Preferences.set({ key, value });
}

export async function removePreference(key: string): Promise<void> {
  await Preferences.remove({ key });
}
